import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  swiper: css`
    .swiper {
      position: relative;
      padding: 0px 16px 0px 16px;
    }
  `,
  paginationContainer: css`
    display: flex;
    width: 100%;
    flex-direction: column;
    position: relative;
  `,
  swiperPagination: css`
    position: absolute;
    right: 16px;
    z-index: 999;
  `,
  paginationPadding: css`
    padding: ${pxToRem(12)} 0px ${pxToRem(12)};
    position: relative;
  `,
  flyer: css`
    max-width: 100%;
    width: 100%;
  `,
  hide: css`
    display: none;
  `,
  expiredFlyerOverlay: css`
    opacity: 0.3;
  `,
  pendingFlyerOverlay: css`
    opacity: 0.1;
  `,
  customPagination: css`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
    gap: 4px;
    margin-block: 0px;
    padding: 0px;
    list-style-type: none;
  `,
  paginationButton: css`
    /* background-color: ${colors.stone}; */
    background-color: #8e8b8b;
    border: none;
    border-radius: 50%;
    width: ${pxToRem(8)};
    height: ${pxToRem(8)};
    padding: 0px;
    cursor: pointer;
    position: relative;
    outline: none;
    transition: background-color 0.3s ease;
    &:focus-visible {
      box-shadow: 0 0 0 2px #cccccc, 0 0 0 4px ${colors.focusOutlineColor};
    }
  `,
  paginationButtonActive: css`
    background-color: ${colors.charcoal};
    &:focus-visible {
      box-shadow: 0 0 0 2px ${colors.charcoal}, 0 0 0 4px ${colors.focusOutlineColor};
    }
  `,
  accessibleVersion: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    gap: 10px;
  `,
};

export default styles;
